module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.SITE_CONFIG.env !== 'production') ? _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Bokning")]), _vm._v(" "), _c('ul', [(_vm.SITE_CONFIG.modules.accomodation) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'accomodation list'
      }
    }
  }, [_vm._v("Boenden")])], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules.accomodation) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'addons'
      }
    }
  }, [_vm._v("Tillval")])], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules.skiletting) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ski rental'
      }
    }
  }, [_vm._v("Skidhyra")])], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules.skipass) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ski pass'
      }
    }
  }, [_vm._v("Liftkort")])], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules.school) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: 'skidskola/oversikt?type=group'
      }
    }
  }, [_vm._v("Skidskola")])], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules.activities) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'activities'
      }
    }
  }, [_vm._v("Barnktiviteter")])], 1) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("Övriga sidor")]), _vm._v(" "), _c('ul', [(_vm.SITE_CONFIG.modules.accomodation) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'my pages'
      }
    }
  }, [_vm._v("Mina sidor")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'shopping cart'
      }
    }
  }, [_vm._v("Varukorg")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("Admin")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin'
      }
    }
  }, [_vm._v("Admin")])], 1), _vm._v(" "), (_vm.SITE_CONFIG.modules.accomodation) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-accomodations'
      }
    }
  }, [_vm._v("Boenden")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-settings'
      }
    }
  }, [_vm._v("Inställningar")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-texts'
      }
    }
  }, [_vm._v("Texter")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-stats-orders'
      }
    }
  }, [_vm._v("Ordrar")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("Inställningar")]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Rensa varukorg och inställningar")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.clean()
      }
    }
  }, [_vm._v("Rensa varukorg, inställningar och logga ut")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.cleanCart()
      }
    }
  }, [_vm._v("Rensa varukorg")])]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.setLocal()
      }
    }
  }, [_vm._v("Sätt backend-URL")]), _vm._v(" "), _c('h2', [_vm._v("Features")]), _vm._v(" "), _c('table', _vm._l((_vm.SITE_CONFIG.features), function(isActive, feature) {
    return _c('tr', {
      key: feature
    }, [_c('td', {
      staticStyle: {
        "padding-right": "5rem"
      }
    }, [_vm._v(_vm._s(feature))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(isActive ? '✅' : '❌'))])])
  }), 0), _vm._v(" "), _c('h2', [_vm._v("Settings")]), _vm._v(" "), _c('table', _vm._l((_vm.SITE_CONFIG.settings), function(value, setting) {
    return _c('tr', {
      key: setting
    }, [_c('td', {
      staticStyle: {
        "padding-right": "5rem"
      }
    }, [_vm._v(_vm._s(setting))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(value))])])
  }), 0)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20a15552"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/StartPage.vue
// module id = 917
// module chunks = 0